import * as React from 'react';
import { PageSection, Spinner } from '@patternfly/react-core';
import { loginStrata } from '@app/utils/strataAuth';

const StrataLogin: React.FunctionComponent = () => {
  React.useEffect(() => {
    try {
      if (!window.sessionStorage.getItem('postAuthRedirectPath')) {
        window.sessionStorage.setItem('postAuthRedirectPath', '/requests');
      }
    } catch (e) {
      console.error('Failed to store post-auth redirect path', e);
    }
    void loginStrata();
  }, []);

  return (
    <PageSection hasBodyWrapper={false}>
      <Spinner size="lg" aria-label="Redirecting to Strata sign-in" />
    </PageSection>
  );
};

export { StrataLogin };
